import { createStyles } from "@mantine/emotion";

export default createStyles ( theme => ( {
	deleteComment: {
		padding         : "1rem",
		backgroundColor : theme.other.darkMode ? theme.other.paletteNew.darkModeInclinedBlack2 : theme.other.paletteNew.secondaryLightGrey

	}

} ) );
